import { choose } from '../../utils/platform';
import NumberChoiceDesktop from './NumberChoice.desktop';
import NumberChoiceMobile from './NumberChoice.mobile';

// Platform chooser: phone (APK or narrow browser) gets the big-tap variant.
export default choose(NumberChoiceDesktop, NumberChoiceMobile);
